import type { CarryEntity, CarryStructureEntity } from '@/types/carryFund';
import type { CarryHolding, CarryStructure } from '../../services/carryService';

/** A legal entity of the structure as the member sees it: only their own row. */
export function memberEntity(
  entity: CarryStructureEntity,
  structure: CarryStructure,
  positions: CarryHolding[]
): CarryEntity {
  const totalUnits = positions.reduce((sum, p) => sum + p.units, 0);
  return {
    ...entity,
    board: structure.board,
    funds: positions.map((p) => ({
      fund_id: p.fund_id,
      name: p.fund_name,
      units: p.units,
    })),
    holders: positions.length
      ? [
          {
            fund_member_id: structure.fund_member_id,
            full_name: structure.full_name,
            holdings: positions.map((p) => ({
              fund_id: p.fund_id,
              units: p.units,
            })),
            total_units: totalUnits,
            vesting_frozen: positions.some(
              (p) => p.vesting_status === 'FROZEN'
            ),
          },
        ]
      : [],
    total_units: totalUnits,
  };
}

export function memberViaLabel(structure: CarryStructure): string {
  return structure.holding?.holding_name ?? 'DR holder';
}
